export const MailIcon = ({ className = "" }: { className?: string }) => (
    <svg
        className={className}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
    >
        <rect
            height="16"
            rx="2"
            width="20"
            x="2"
            y="4"
        />
        <path d="m22 7-10 5L2 7" />
    </svg>
);
